<template>
  <v-dialog :value="dialogIsVisible" width="800" persistent>
    <v-card v-if="dataset && transaction" :loading="loading">
      <AdCardTitle dialog>Smart Clone</AdCardTitle>
      <v-card-text class="pa-4">
        <AdInfoOwl v-if="error" error>{{ error.message }}</AdInfoOwl>
        <div v-if="preflightData">
          <v-simple-table>
            <tbody>
              <tr>
                <th style="width: 60%">Will be transferred</th>
                <td style="width: 40%">{{ preflightData.conceptsTransferred}}</td>
              </tr>
              <tr class="no-matches-row">
                <th style="width: 60%">No matches</th>
                <td style="width: 40%">{{ preflightData.nomatches?.count}}</td>
              </tr>
              <tr v-if="preflightData.nomatches?.failed?.length > 0" class="no-matches-details-row">
                <td colspan="2">
                  <v-data-table
                    :headers="noMatchesHeaders"
                    :items="preflightData.nomatches.failed"
                    :footer-props="{itemsPerPageOptions: [5, 10]}"
                    item-key="ref"
                    dense
                  >
                    <template #item.concept="{ item }">
                      <AdStatusDot v-if="sourceConcept(item).statusCode" class="mr-1" tooltip :status="sourceConcept(item).statusCode" />
                      {{ $filters.getMatchingTranslation({ value: sourceConcept(item).name }) || '?' }}
                    </template>
                  </v-data-table>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <AdButton type="cancel" @click="dialogIsVisible = false" />
        <AdButton type="clone" :disabled="loading || !!error" @click="onConfirm">{{ $t('smart-cloning') }}</AdButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ScenarioService from '@/services/ScenarioService'
import AdInfoOwl from '../Utilities/AdInfoOwl.vue'
export default {
  components: { AdInfoOwl },
  name: 'SmartCloneDialog',
  props: {
    // Dialog visibility
    value: {
      type: Boolean,
      default: false
    },
    // Transaction object
    transaction: {
      type: Object,
      default: null
    },
    // The new source dataset
    dataset: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      error: null,
      loading: false,
      preflightData: null
    }
  },
  computed: {
    dialogIsVisible: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    noMatchesHeaders () {
      return [
        {
          text: this.$t('concept'),
          value: 'concept',
          cellClass: 'red--text',
          width: '60%',
          sortable: false
        },
        {
          text: this.$t('id'),
          value: 'ref',
          cellClass: 'red--text',
          width: '40%',
          sort: this.$filters.numericStringComparator
        }
      ]
    }
  },
  methods: {
    onConfirm () {
      if (!this.preflightData?.representingTemplate) {
        this.$oops('Invalid preflight data')
        return
      }
      const data = structuredClone(this.preflightData.representingTemplate)
      this.$emit('clone', data)
      this.dialogIsVisible = false
    },
    async preflight () {
      if (!this.transaction?.id || !this.transaction.effectiveDate || !this.dataset?.id || !this.dataset.effectiveDate) {
        this.$oops('Invalid transaction or dataset')
        return
      }
      this.loading = true
      this.error = null
      try {
        const res = await ScenarioService.smartCloneRepresentingTemplate({
          transactionId: this.transaction.id,
          transactionEffectiveDate: this.transaction.effectiveDate,
          datasetId: this.dataset.id,
          datasetEffectiveDate: this.dataset.effectiveDate
        })
        this.preflightData = res.data ?? null
      } catch (error) {
        console.log(error)
        this.error = error
        const errorMessage = error?.response?.data?.description || error?.response?.statusText || 'Error'
        this.$oops(errorMessage)
      }
      this.loading = false
    },
    sourceConcept (item) {
      return item?.sourceConcept?.[0]
    }
  },
  watch: {
    dialogIsVisible (value) {
      if (value) {
        this.preflight()
      } else {
        this.preflightData = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
tr:has(+ tr.no-matches-details-row:hover) {
  background: #eee;
}
.no-matches-details-row > td {
  padding: 0 !important;
}

.no-matches-row:hover +.no-matches-details-row,
.no-matches-details-row:hover {
  ::v-deep tr {
    background: #fafafa;
  }
}
</style>
